import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import index from '@/views/index'
import yueke3 from '@/views/yueke3'
import yuekelist from '@/views/yuekelist'
import Paymentsuccessful from '@/views/Paymentsuccessful'
import zhanghu from '@/views/zhanghu'
import onevone from "@/views/1V1";
import mycourse from "@/views/myCourse"
import vipcourse from "@/views/1V1Course"
import login from '@/views/login'
import Paymentdetails from '@/views/Paymentdetails'
import downLoadApp from '@/views/downLoadApp'
import { Message } from "element-ui";
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: "/",
      name: "index",
      component: index,
    },
    {
      path: "/myClass",
      name: "MyClass",
      component: mycourse,
    },
    {
      path: "/vipcourse",
      name: "VipCourse",
      component: vipcourse,
    },
    {
      path: "/oneclass",
      name: "1V1",
      component: onevone,
    },
    {
      path: "/Paymentsuccessful/:setid/:kechengid/:shangpingid",
      name: "Mycourse4",
      component: Paymentsuccessful,
    },
    {
      path: "/Paymentdetails/:setid/:kechengID",
      name: "Mycourse3",
      component: Paymentdetails,
    },
    {
      path: "/yuekelist/:setid/:goodsId",
      name: "Mycourse2",
      component: yuekelist,
    },
    {
      path: "/yueke3/:setid",
      name: "Mycourse1",
      component: yueke3,
    },
    {
      path: "/yueke3/:setid/:class_id",
      name: "Mycourse",
      component: yueke3,
    },
    {
      path: "/zhanghu",
      name: "zhanghu",
      component: zhanghu,
    },
    {
      path: "/downloadApp",
      name: "downLoadApp",
      component: downLoadApp,
    },
    {
      path: "/login",
      name: "login",
      component: login,
    },
    {
      path: '/preview',
      name: 'Preview',
      component: () => import('@/views/preview/index.vue')
    },
    {
      path: "/home",
      name: "Home",
      component: () => import("@/views/mofang"),
    },
    {
      path: "/course-page",
      name: "CoursePage",
      component: () => import("@/views/mofang/coursePage.vue"),
    },
  ],
});
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.name === 'zhanghu' && !token) {
    next({ path: '/' })
  } else {
    next()
  }
  if ((to.name == "MyClass" && !token) || (to.name == "VipCourse" && !token)) {
    Message.error("请登录账号查看课程");
  }
})

export default router
